var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('img',{staticClass:"notfound",attrs:{"src":require("@/assets/images/404.png"),"alt":""}}),_c('div',{staticClass:"backHome",on:{"click":_vm.backHome}},[_vm._v("返回首页")])])}
var staticRenderFns = []

export { render, staticRenderFns }